import { useState, useEffect } from "react";

import JiraSoftwareNav from "@/templates/software/jira/sections/nav-bar/software-jira-navbar";

import { PaidJiraAiBackground } from "../sections/cfind-4666-frictionless-first-look/paid-jira-ai-background";
import { PaidJiraAiDisclaimer } from "../sections/cfind-4666-frictionless-first-look/paid-jira-ai-disclaimer";
import { PaidJiraAiHeader } from "../sections/cfind-4666-frictionless-first-look/paid-jira-ai-header";
import { PaidJiraAiJiraPreview } from "../sections/cfind-4666-frictionless-first-look/paid-jira-ai-jira-preview";
import { PaidJiraAiPreviewModal } from "../sections/cfind-4666-frictionless-first-look/paid-jira-ai-preview-modal";
import { PaidJiraAiTeamTypeMadLibPrompt } from "../sections/cfind-4666-frictionless-first-look/paid-jira-ai-team-type-mad-lib-prompt";

import {
    JiraAiFFLProvider,
    useJiraAiFFL
} from "./hooks/use-jira-ai-ffl-context";

export const PaidLandingJiraAiContent = () => {
    const { cgsDataLoading, selectedTeamType } = useJiraAiFFL();

    const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);

    useEffect(() => {
        if (cgsDataLoading) {
            setIsPreviewModalOpen(true);
        }
    }, [cgsDataLoading]);

    return (
        <main>
            <JiraSoftwareNav />
            <PaidJiraAiBackground />
            <PaidJiraAiHeader />
            <PaidJiraAiTeamTypeMadLibPrompt />
            <PaidJiraAiDisclaimer />
            {isPreviewModalOpen && (
                <PaidJiraAiPreviewModal
                    onClose={() => setIsPreviewModalOpen(false)}
                />
            )}
            <PaidJiraAiJiraPreview teamType={selectedTeamType} />
        </main>
    );
};

export const PaidLandingJiraAiTemplate = () => (
    <JiraAiFFLProvider>
        <PaidLandingJiraAiContent />
    </JiraAiFFLProvider>
);
